import React from 'react';
import PropTypes from 'prop-types';
import { ArrowRight16 } from '@carbon/icons-react';
import { css } from '@emotion/core';
import { NavItem, Text } from '..';

function NavLink({ label, handler }) {
  const textProps = {
    as: 'span',
    intl: label.intl,
    children: label.intl ? null : label,
  };

  return (
    <NavItem as="button" onClick={handler} css={styles.button}>
      <Text className="interactive-widget__nav-link-label" {...textProps} />
      <ArrowRight16 css={styles.icon} />
    </NavItem>
  );
}

NavLink.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      intl: PropTypes.string.isRequired,
    }),
  ]).isRequired,
  handler: PropTypes.func.isRequired,
};

const styles = {
  button: css`
    min-block-size: 9.25rem;
    display: grid;
    grid-template-rows: minmax(0, 1fr) auto;
    grid-template-columns: minmax(0, 1fr) 1.5rem;
    gap: 1rem;
    text-align: start;
  `,
  icon: css`
    inline-size: 1.5rem;
    block-size: 1.5rem;
    grid-row: 2;
    grid-column: 2;
    color: var(--color-interactive);
  `,
};

export default NavLink;
